export default __webpack_public_path__ + "static/media/2160.227ea799.png";